export const convertArrToObj = (arr) => {
  return arr.reduce(function(prev, curr) {
    prev[curr.id] = curr;
    return prev;
  }, {});
};



// WEBPACK FOOTER //
// ./src/businessLogic/convertArrToObj.js